module.exports = __webpack_public_path__ + "img/statistics_black.b086ffbf.svg";